import { httpsCallable } from 'firebase/functions';
import { functions } from '@/lib/firebase';
import type {
  Advertiser,
  AdvertiserWallet,
  AdvertiserTransaction,
  CpcTier,
} from '../../../shared/types/advertiser';

export interface WalletState {
  advertiser: Advertiser | null;
  wallet: AdvertiserWallet | null;
  transactions: AdvertiserTransaction[];
  tier: CpcTier | null;
}

interface CreateDepositResponse {
  id: string;
  url: string;
}

export async function getWalletState(advertiserId: string, transactionLimit = 50) {
  const fn = httpsCallable<{ advertiserId: string; transactionLimit?: number }, WalletState>(
    functions,
    'getAdvertiserWalletState',
  );
  const { data } = await fn({ advertiserId, transactionLimit });
  return data;
}

export async function createDeposit(
  advertiserId: string,
  amountUsd: number,
  successUrl: string,
  cancelUrl: string,
) {
  const fn = httpsCallable<
    { advertiserId: string; amountUsd: number; successUrl: string; cancelUrl: string },
    CreateDepositResponse
  >(functions, 'createAdvertiserDeposit');
  const { data } = await fn({ advertiserId, amountUsd, successUrl, cancelUrl });
  return data;
}

export async function updateRechargeSettings(
  advertiserId: string,
  autoRechargeEnabled: boolean,
  rechargeThresholdUsd: number,
  rechargeAmountUsd: number,
) {
  const fn = httpsCallable<
    {
      advertiserId: string;
      autoRechargeEnabled: boolean;
      rechargeThresholdUsd: number;
      rechargeAmountUsd: number;
    },
    { ok: boolean }
  >(functions, 'updateAdvertiserRechargeSettings');
  const { data } = await fn({
    advertiserId,
    autoRechargeEnabled,
    rechargeThresholdUsd,
    rechargeAmountUsd,
  });
  return data;
}
